import React, { useState, useContext, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  FormGroup,
  LinearProgress,
  Modal,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import { BoxCss, Button, TxtTitle } from "./style";
import { Col, Container, Row } from "reactstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { LoginContext } from "../../context/login/LoginContext";
import { useTranslation } from "react-i18next";
import { ContactContext } from "../../context/contact/ContactContext";
import { useMsal } from "@azure/msal-react";

const ModalPersonalDataPolicy = ({ open, setOpen }) => {
  const { accounts } = useMsal();
  const { t } = useTranslation();
  const { upLogoutRedirect } = useContext(LoginContext);
  const {
    primaryContact,
    getLegalDocument,
    getContactInformation,
    legalDocument,
    personalData,
    postSendAgreements,
    postApproveAgreements,
  } = useContext(ContactContext);
  const [load, setLoad] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [checkedPolitics, setCheckedPolitics] = useState(false);
  const handleScroll = (e) => {
    const bottom =
      parseInt((e.target.scrollHeight - e.target.scrollTop).toFixed(0)) ===
      e.target.clientHeight;
    if (bottom) {
      setCheckedPolitics(true);
    } else {
      setCheckedPolitics(false);
    }
  };
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleClose = () => setOpen(false);

  const handleApproveAgreements = async () => {
    setLoad(true);
    const data = {
      acceptedAgreements: 1,
      email: accounts[0].username,
      gender: 0,
      lastName: primaryContact.surname,
      liActiveDirectoryGuid_STR: accounts[0].localAccountId,
      name: primaryContact.givenName,
      typeContact: 3,
    };
    await postApproveAgreements(data);
    await postSendAgreements(data);
    setLoad(false);
    setOpen(!open);
  };
  const handleLogOut = () => {
    upLogoutRedirect();
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await getLegalDocument();
    };
    fetchData2();
  }, []);

  return (
    // {load && <LinearProgress color="error" />}
    <Modal open={open}>
      <BoxCss>
        <Button
          type="submit"
          onClick={() => handleLogOut()}
          style={{
            width: "140px",
            marginLeft: "75%",
            marginTop: "5px",
            backgroundColor: "transparent",
            color: "gray",
            fontSize: "1.8vh",
          }}
        >
          <b>{t("logout")}</b>
        </Button>
        <Container style={{ textAlign: "center" }}>
          <img className="logoLifeFooter" alt="logoLife" src="/logo-life.png" />
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h1"
            style={{ marginBottom: "40px" }}
          >
            Privacidad de Datos Personales
          </Typography>
        </Container>
        <Row>
          <Col xs={1} style={{ paddingBlock: "20px" }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={checkedPolitics}
                    name="acceptedAgreements"
                    onChange={() => setCheckedPolitics(!checkedPolitics)}
                  />
                }
              />
            </FormGroup>
          </Col>
          <Col>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <TxtTitle>
                He leído y acepto{" "}
                <a href={legalDocument.urldocument} target="_blank">
                  La política de privacidad de datos personales
                </a>
                .
              </TxtTitle>
            </Typography>
          </Col>
        </Row>
        <Row>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography sx={{ width: "100%", flexShrink: 0 }}>
                LEER POLÍTICA DE PRIVACIDAD
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Stack
                direction="column"
                sx={{ height: "300px", overflowY: "scroll" }}
                spacing={0.2}
                alignItems="left"
                onScroll={handleScroll}
              >
                <Typography
                  style={{
                    textAlign: "center",
                    paddingInline: "30px",
                    fontWeight: "bold",
                    marginBlock: "10px",
                  }}
                >
                  {legalDocument.documentTit}
                </Typography>
                <Typography
                  style={{ textAlign: "justify", paddingInline: "30px" }}
                >
                  {legalDocument !== undefined &&
                    legalDocument.textDocument !== undefined &&
                    legalDocument.textDocument !== "" && (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: legalDocument.textDocument
                            .replaceAll("\n", "<br/>")
                            .replaceAll(
                              "{0}",
                              new Date().toISOString().slice(0, 10).toString()
                            )
                            .replaceAll(
                              "{1}",
                              primaryContact.givenName +
                                " " +
                                primaryContact.surname
                            )
                            .replaceAll("{2}", "N/A")
                            .replaceAll(
                              "{3}",
                              legalDocument.nameRespPersonalData
                            )
                            .replaceAll("{4}", legalDocument.positionInCompany),
                        }}
                      ></div>
                    )}
                </Typography>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Row>

        <Row>
          {checkedPolitics ? (
            <Button type="submit" onClick={() => handleApproveAgreements()}>
              <b>ACEPTAR</b>
            </Button>
          ) : (
            <Button
              type="submit"
              onClick={() => handleClose()}
              disabled={true}
              style={{ backgroundColor: "gray" }}
            >
              <b style={{ color: "white" }}>ACEPTAR</b>
            </Button>
          )}
        </Row>
      </BoxCss>
    </Modal>
  );
};

export default ModalPersonalDataPolicy;
